import { createRouter, createWebHashHistory } from 'vue-router';

import AuthLayout from './layouts/Auth';
import AppLayout from './layouts/App';
import NextLayout from './layouts/Next';

const vueRouter = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes: [
		{
			path: '/',
			component: AppLayout,
			meta: { auth: true, hidden: true },
			children: [
				{
					name: 'home',
					path: '/',
					meta: {
						auth: 'editor',
						title: 'Dashboard',
						icon: ['fal', 'tachometer-alt'],
						breads: [],
					},
					component: () => import('./views/dashboard/index'),
				},
				{
					name: 'pm2',
					path: '/pm2',
					meta: {
						auth: 'superadmin',
						title: 'Procesos PM2',
						icon: ['fal', 'server'],
						breads: [],
					},
					component: () => import('./views/management/pm2/index'),
				},
				{
					name: 'templater',
					path: '/plantillas-programadas',
					meta: {
						auth: 'editor',
						title: 'Plantillas programadas',
						icon: ['fal', 'calendar-alt'],
						breads: [],
					},
					component: () => import('./views/templater/index'),
				},
				{
					name: 'templaterCreate',
					path: '/crear-plantilla',
					meta: {
						auth: 'editor',
						title: 'Crear plantilla',
						icon: ['fal', 'magic'],
						breads: [],
					},
					component: () => import('./views/templater/create'),
				},
				{
					name: 'chat',
					path: '/chat',
					meta: {
						auth: 'editor',
						title: 'Chat del equipo',
						icon: ['fal', 'comments'],
						breads: [],
					},
					component: () => import('./views/chat/index'),
				},
				{
					name: 'statistics',
					path: '/aliexpress/statistics',
					meta: {
						auth: 'superadmin',
						title: 'Estadísticas',
						icon: ['fal', 'analytics'],
						breads: [],
					},
					component: () => import('./views/aliexpress/statistics/index'),
				},
				{
					name: 'posts-aliexpress',
					path: '/posts-aliexpress',
					meta: {
						auth: 'editor',
						title: 'Copiar posts',
						icon: ['fal', 'paste'],
						breads: [],
					},
					component: () => import('./views/aliexpress/copy-posts/index'),
				},
				{
					name: 'posts',
					path: '/posts',
					meta: {
						auth: 'editor',
						title: 'Posts',
						icon: ['fal', 'ticket-alt'],
						breads: [

						],
						topbar: {
							buttons: [{
								text: 'Resetear filtro',
								icon: ['fal', 'eraser'],
								variant: 'outline-secondary',
								class: '',
								event: 'resetFilters',
							}],
						},
					},
					component: () => import('./views/posts/list/index'),
				},
				{
					name: 'postAdd',
					path: '/post/nuevo',
					meta: {
						title: 'Nuevo post',
						auth: 'editor',
						breads: [{
							name: 'Posts',
							url: { name: 'posts' },
							icon: ['fal', 'ticket-alt'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los posts',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToPosts',
							}],
						},
					},
					component: () => import('./views/posts/form/index'),
				},
				{
					name: 'postEdit',
					path: '/post/edicion/:id',
					meta: {
						title: 'Editar post',
						auth: 'editor',
						breads: [{
							name: 'Posts',
							url: { name: 'posts' },
							icon: ['fal', 'ticket-alt'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los posts',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToPosts',
							}],
						},
					},
					component: () => import('./views/posts/form/index'),
				},
				{
					name: 'postExcel',
					path: '/post/excel',
					meta: {
						title: 'Subir excel',
						auth: 'editor',
						breads: [{
							name: 'Posts',
							url: { name: 'posts' },
							icon: ['fal', 'ticket-alt'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los posts',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToPosts',
							}],
						},
					},
					component: () => import('./views/excel/index'),
				},
				{
					name: 'excelAmazon',
					path: '/amazon/',
					meta: {
						title: 'Amazon Excel',
						auth: 'editor',
					},
					component: () => import('./views/amazon-excel/index'),
				},
				{
					name: 'post',
					path: '/post/:id',
					meta: {
						title: 'Ficha de Post',
						auth: 'editor',
						breads: [{
							name: 'Posts',
							url: { name: 'posts' },
							icon: ['fal', 'ticket-alt'],
						}, {
							name: 'Ficha',
							url: null,
							icon: null,
						}],
						topbar: {
							buttons: [{
								text: 'Todos los posts',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToPosts',
							}],
						},
					},
					component: () => import('./views/posts/view/index'),
				},
				{
					name: 'pendingPosts',
					path: '/posts/pendientes',
					meta: {
						auth: 'editor',
						title: 'Pendientes de moderación',
						breads: [{
							name: 'Posts',
							url: { name: 'posts' },
							icon: ['fal', 'ticket-alt'],
						}],
						topbar: {
							buttons: [{
								text: 'Resetear filtro',
								icon: ['fal', 'eraser'],
								variant: 'outline-secondary',
								class: '',
								event: 'resetFilters',
							}],
						},
					},
					component: () => import('./views/posts/list/pending'),
				},
				{
					name: 'tags',
					path: '/tags',
					meta: {
						auth: 'editor',
						title: 'Todos las tags',
						breads: [{
							name: 'Tags',
							url: { name: 'tags' },
							icon: ['fal', 'tags'],
						}],
						topbar: {
							buttons: [{
								text: 'Nuevo tag',
								icon: ['fal', 'plus-circle'],
								variant: 'outline-primary',
								class: '',
								event: 'newTag',
								auth: 'admin',
							}, {
								text: 'Resetear filtro',
								icon: ['fal', 'eraser'],
								variant: 'outline-secondary',
								class: 'd-none d-sm-inline-block',
								event: 'resetFilters',
							}],
						},
					},
					component: () => import('./views/tags/index'),
				},
				{
					name: 'tagEdit',
					path: '/tag/edicion/:id',
					meta: {
						title: 'Editar tag',
						auth: 'editor',
						breads: [{
							name: 'Tags',
							url: { name: 'tags' },
							icon: ['fal', 'tags'],
						}],
						topbar: {
							buttons: [{
								text: 'Todas las tags',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToTags',
							}],
						},
					},
					component: () => import('./views/tags/form/index'),
				},
				{
					name: 'tagAdd',
					path: '/tag/nuevo',
					meta: {
						title: 'Nueva categoría',
						auth: 'editor',
						breads: [{
							name: 'Tags',
							url: { name: 'tags' },
							icon: ['fal', 'tags'],
						}],
						topbar: {
							buttons: [{
								text: 'Todas las tags',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToTags',
							}],
						},
					},
					component: () => import('./views/tags/form/index'),
				},
				{
					name: 'summaryAdd',
					path: '/resumenes/nuevo',
					meta: {
						auth: 'editor',
						title: 'Nuevo resumen',
						icon: ['fal', 'box-full'],
						topbar: {
							buttons: [{
								text: 'Ver todos',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'listSummaries',
							}],
						},
					},
					component: () => import('./views/summaries/view'),
				},
				{
					name: 'summaryEdit',
					path: '/resumenes/:id',
					meta: {
						auth: 'editor',
						title: 'Resúmen diario',
						icon: ['fal', 'box-full'],
						topbar: {
							buttons: [{
								text: 'Nuevo resumen',
								icon: ['fal', 'plus-circle'],
								variant: 'outline-secondary',
								class: '',
								event: 'addSummaries',
							}],
						},
					},
					component: () => import('./views/summaries/view'),
				},
				{
					name: 'comments',
					path: '/comentarios',
					meta: {
						auth: 'editor',
						title: 'Comentarios',
						icon: ['fal', 'comments-alt'],
						topbar: {
							buttons: [{
								text: 'Refrescar',
								icon: ['fal', 'sync'],
								variant: 'outline-secondary',
								class: '',
								event: 'refreshComments',
							}],
						},
					},
					component: () => import('./views/comments/index'),
				},
				{
					name: 'users',
					path: '/usuarios',
					meta: {
						title: 'Usuarios',
						icon: ['fal', 'users'],
						auth: 'editor',
						topbar: {
							buttons: [{
								text: 'Nuevo usuario',
								icon: ['fal', 'plus-circle'],
								variant: 'outline-secondary',
								class: '',
								event: 'addUser',
							}],
						},
					},
					component: () => import('./views/users/index'),
				},
				{
					name: 'user',
					path: '/usuario/:id',
					meta: {
						title: 'Perfil de usuario',
						auth: 'editor',
						breads: [{
							name: 'Usuarios',
							url: { name: 'users' },
							icon: ['fal', 'users'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los usuarios',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToUsers',
							}],
						},
					},
					component: () => import('./views/users/view'),
				},
				{
					name: 'tracking',
					path: '/tracking',
					meta: {
						title: 'Tracking',
						auth: 'admin',
						breads: [],
						topbar: {
							buttons: [],
						},
					},
					component: () => import('./views/tracks/index'),
				},
				{
					name: 'coupons',
					path: '/coupons',
					meta: {
						auth: 'editor',
						title: 'Cupones',
						icon: ['fal', 'percent'],
						breads: [

						],
						topbar: {
							buttons: [{
								text: 'Resetear filtro',
								icon: ['fal', 'eraser'],
								variant: 'outline-secondary',
								class: '',
								event: 'resetFilters',
							}],
						},
					},
					component: () => import('./views/coupons/list/index'),
				},
				{
					name: 'couponEdit',
					path: '/coupon/edicion/:id',
					meta: {
						title: 'Editar cupón',
						auth: 'editor',
						breads: [{
							name: 'Cupones',
							url: { name: 'coupons' },
							icon: ['fal', 'percent'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los cupons',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToCoupons',
							}],
						},
					},
					component: () => import('./views/coupons/form/index'),
				},
				{
					name: 'couponAdd',
					path: '/coupon/nuevo',
					meta: {
						title: 'Nuevo cupón',
						auth: 'editor',
						breads: [{
							name: 'Cupones',
							url: { name: 'coupons' },
							icon: ['fal', 'percent'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los cupons',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToCoupons',
							}],
						},
					},
					component: () => import('./views/coupons/form/index'),
				},
				{
					name: 'pendingCoupons',
					path: '/coupons/pending',
					meta: {
						auth: 'editor',
						title: 'Pendientes de moderación',
						breads: [{
							name: 'Cupones',
							url: { name: 'coupons' },
							icon: ['fal', 'percent'],
						}],
						topbar: {
							buttons: [{
								text: 'Todos los cupons',
								icon: ['fal', 'list'],
								variant: 'outline-secondary',
								class: '',
								event: 'goToCoupons',
							}],
						},
					},
					component: () => import('./views/coupons/list/pending'),
				},
				{
					name: 'linkStats',
					path: '/estadisticas/links',
					meta: {
						auth: 'editor',
						title: 'Estadísticas de links',
						icon: ['fal', 'link'],
						breads: [],
						topbar: { buttons: [] },
					},
					component: () => import('./views/stats/link-stats/index'),
				},
				{
					name: 'banners',
					path: '/banners',
					meta: {
						auth: 'editor',
						title: 'Banners',
						icon: ['fal', 'megaphone'],
						breads: [{
							name: 'Banners',
							url: { name: 'banners' },
							icon: ['fal', 'banners'],
						}],
						topbar: {
							buttons: [{
								text: 'Nuevo banner',
								icon: ['fal', 'plus-circle'],
								variant: 'outline-primary',
								class: '',
								event: 'newBanner',
								auth: 'admin',
							}],
						},
					},
					component: () => import('./views/banners/view'),
				},
			],
		},
		// System Pages
		{
			path: '/system',
			component: AuthLayout,
			redirect: '/login',
			children: [
				{
					name: '_login',
					path: '/login',
					meta: {
						title: 'Login',
						auth: false,
					},
					component: () => import('./views/system/login/index'),
				},
				{
					name: '_forgotPassword',
					path: '/recuperar-credenciales',
					meta: {
						title: 'Forgot Password',
						auth: false,
					},
					component: () => import('./views/system/forgot-password/index'),
				},
				{
					name: '_403',
					path: '/403',
					meta: {
						title: 'Error 403',
						auth: false,
					},
					component: () => import('./views/system/403/index'),
				},
				{
					name: '_404',
					path: '/404',
					meta: {
						title: 'Error 404',
						auth: false,
					},
					component: () => import('./views/system/404/index'),
				},
				{
					name: '_500',
					path: '/500',
					meta: {
						title: 'Error 500',
						auth: false,
					},
					component: () => import('./views/system/500/index'),
				},
			],
		},
		// New UI shell (fase 1) — coexists with the legacy AppLayout above
		{
			path: '/next',
			component: NextLayout,
			meta: { auth: true, hidden: true },
			children: [
				{
					name: 'next-overview',
					path: '',
					meta: { auth: true, title: 'Panel (nueva interfaz)' },
					component: () => import('./views/next/index'),
				},
			],
		},
		// Catch-all (Vue Router 4 syntax)
		{
			path: '/:pathMatch(.*)*',
			redirect: '/404',
		},
	],
});

export default vueRouter;
